module.exports = __webpack_public_path__ + "img/lead-commission.a91ce190.svg";